import React from 'react';
import BasicButton from './Button/BasicButton';
import BasicTextfield from './Text/BasicTextfield';
import HorizontalLineText from './Text/HorizontalLineText';
import Colortheme from '../Theme/Colortheme';
import { AvatarChooser, randomAvatar } from './Players/AvatarChooser';
import Divider from './HelperElements/Divider';
import alertify from 'alertifyjs';
import 'alertifyjs/build/css/alertify.css';
import Cookies from 'js-cookie'
import { randomUsername } from '../Utils/UsernameGenerator'
import Discord from './Social/Discord';
import Credits from './Social/Credits';
import { messyBorderStyle } from '../Utils/StyleUtils';
import RevealCanvas from './Canvas/RevealCanvas';

class SharePage extends React.Component {

    constructor(props) {
        super(props);

        this.style = {
            centerField: {
                padding: '20px',
                margin: '10px',
                backgroundColor: '#FFFFFF',
                maxWidth: '800px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                ...messyBorderStyle("main_startpage"),
            },
        };

        this.state = {};
    }

    componentDidMount() {
        var divStyle = getComputedStyle(this.contentDiv);

        var divWidth = this.contentDiv.clientWidth;
        divWidth -= parseFloat(divStyle.paddingLeft) + parseFloat(divStyle.marginLeft) + parseFloat(divStyle.paddingRight) + parseFloat(divStyle.marginRight);

        this.setState({
            width: divWidth
        })
    }

    render() {


        const query = new URLSearchParams(this.props.location.search);
        var prompt = atob(query.get('data'))
        return (
            <div>
                <div style={this.style.centerField} ref={(div) => this.contentDiv = div}>
                    <RevealCanvas width={this.state.width}>
                        <img src={"https://i.imgur.com/" + this.props.match.params.imageId + ".png"} style={{ width: '100%'}} />
                    </RevealCanvas>
                    <div style={{
                        fontSize: 'min(calc(10px + 1.5vw), 25px)',
                        padding: '1em',
                        paddingBottom: '0.25em',
                    }}><b>{prompt}</b></div>
                </div>
                <Discord />
                <Credits showTutorialLink={true} />
            </div >
        );
    }
}

export default SharePage;